import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import router from './router'
import store from '@/store'
import { isAuth } from '@/utils'
import httpRequest from '@/utils/httpRequest'
import VueCookie from 'vue-cookie'
import dataV from '@jiaminghi/data-view';
// import '@/element-ui-theme/style.css'
import 'element-ui/lib/theme-chalk/index.css'
// 引入全局css
import './assets/scss/style.scss';
// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
//引入echart
//4.x 引用方式
// import echarts from 'echarts'
//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
// 挂载全局
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法
Vue.config.productionTip = false
// 全局注册
Vue.component('icon', Icon);
Vue.use(dataV);
Vue.use(ElementUI)
Vue.use(VueCookie)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js